import { ChangeDetectionStrategy, Component } from "@angular/core";

import { RegisterYourInterestFacade } from "@hermes/states/register-your-interest";

@Component({
    selector: "h-call-to-action-register-your-interest",
    templateUrl: "./call-to-action-register-your-interest.component.html",
    styleUrl: "./call-to-action-register-your-interest.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallToActionRegisterYourInterestComponent {
    constructor(
        public registerYourInterestFacade: RegisterYourInterestFacade,
    ) {}

    public openRegisterYourInterest(): void {
        this.registerYourInterestFacade.openRegisterYourInterest();
    }
}
